import  { createContext } from 'react';

const AddNodeContext = createContext(null)

export default AddNodeContext;